import type { ReturnRequestStatusDto } from "@babackapp/private-api-client";
import { TruckIcon } from "@heroicons/react/24/solid";
import { PackageCheck, PackageX } from "lucide-react";
import type { ReactNode } from "react";

export type AlertConfig = {
  variant: "default" | "destructive" | "pending" | "info";
  icon: ReactNode;
  titleKey: string;
  descriptionKey: string;
};

// titleKey/descriptionKey are resolved dynamically in status-alert.tsx (t(config.titleKey)),
// so the widget-key scanner can't pick them up via its static t("...") regex. Annotated here
// so they still show up in the dashboard's "Wording du portail" panel.
// @widget-key: returnRequests.details.timeline.cancelled confirmation
// @widget-key: returnRequests.details.status.cancelled.description confirmation
// @widget-key: returnRequests.details.timeline.resolved confirmation
// @widget-key: returnRequests.details.status.resolved.description confirmation
// @widget-key: returnRequests.details.status.treated.title confirmation
// @widget-key: returnRequests.details.status.treated.description confirmation
// @widget-key: returnRequests.details.timeline.shipped confirmation
// @widget-key: returnRequests.details.status.shipped.description confirmation
// @widget-key: returnRequests.details.timeline.shipping confirmation
// @widget-key: returnRequests.details.timeline.approved confirmation
// @widget-key: returnRequests.details.status.approved.description confirmation
// @widget-key: returnRequests.details.timeline.waiting confirmation
// @widget-key: returnRequests.details.status.waiting.description confirmation
export function resolveAlertConfig(status: ReturnRequestStatusDto): AlertConfig | null {
  if (status.cancelled.done) {
    return { variant: "destructive", icon: <PackageX />, titleKey: "returnRequests.details.timeline.cancelled", descriptionKey: "returnRequests.details.status.cancelled.description" };
  }
  if (status.resolved.done) {
    return { variant: "default", icon: <PackageCheck />, titleKey: "returnRequests.details.timeline.resolved", descriptionKey: "returnRequests.details.status.resolved.description" };
  }
  if (
    status.treatedMerchant.done ||
    status.treatedLogistician.done ||
    status.partiallyTreatedMerchant.done ||
    status.partiallyTreatedLogistician.done
  ) {
    return { variant: "info", icon: <PackageCheck />, titleKey: "returnRequests.details.status.treated.title", descriptionKey: "returnRequests.details.status.treated.description" };
  }
  if (status.shipped.done) {
    return { variant: "info", icon: <TruckIcon />, titleKey: "returnRequests.details.timeline.shipped", descriptionKey: "returnRequests.details.status.shipped.description" };
  }
  if (status.shipping.done) {
    return { variant: "pending", icon: <TruckIcon />, titleKey: "returnRequests.details.timeline.shipping", descriptionKey: "returnRequests.details.status.approved.description" };
  }
  if (status.approved.done) {
    return { variant: "pending", icon: <TruckIcon />, titleKey: "returnRequests.details.timeline.approved", descriptionKey: "returnRequests.details.status.approved.description" };
  }
  if (status.waiting.done) {
    return { variant: "pending", icon: <TruckIcon />, titleKey: "returnRequests.details.timeline.waiting", descriptionKey: "returnRequests.details.status.waiting.description" };
  }
  return null;
}
